<template>
  <div class="modal_wrap on">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">위치 서비스 사용 불가</h1>
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <div class="center">
              위치 정보를 확인할 수 없습니다.<br />
              <br />
              서비스를 위해 위치 서비스를 ON으로<br />
              설정해 주세요.
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" v-on:click="$emit('close')">
              닫기
            </button>
            <button class="btn" v-on:click="$emit('setting')">
              설정하러 가기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GPSOffModal',
};
</script>

<style scoped></style>
